import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, FormGroup, FormControl, InputLabel, Select, MenuItem, Typography, Divider } from '@mui/material';
import FASiteOptionsDataHelper from "../../data/FallowARM/FASiteOptionsDataHelper";
import sharedStyles from "../sharedPageStyles.module.scss";
import LoadingComponent from '../../components/LoadingComponent';

class FASoilTypeSelectionStep extends Component {
  constructor(props) {
    super(props);
    this.state = {
      soilList: [],
      loadingState: 'loading',
      error: {},
    }
  }

  // Function will receive a soil List item.
  onSoilTypeSelection = (event, value) => {
    const soilKey = value.props.value;
    if (soilKey) {
      // console.log(this.state.soilList);
      const thisSoilType = this.state.soilList.find((s) => s.key === soilKey);
      if (thisSoilType) {
        const selection = {
          soil: thisSoilType.soil,
          pawc: thisSoilType.pawc,
          description: thisSoilType.description,
          key: thisSoilType.key,
          site: this.props.Site,
          siteId: this.props.SiteId,
        }
        this.props.handleSoilTypeSelection(selection);
      }
    }
  }

  // getSoilTypeSelectionValue = (site, soil_type) => {
  //   return JSON.stringify({
  //     site: site,
  //     soil_type: soil_type,
  //     action: "update",
  //     pawc: this.state.soilPawcMapping[site][soil_type] // this might be null
  //   });
  // }

  componentDidMount() {
    var self = this;

    FASiteOptionsDataHelper.siteOptionsFromAPI(this.props.Site)
      .then((values) => {
        // console.log('Values from API', values);
        if (values.data.soilList.length > 0) {
          self.setState({
            soilList: [...values.data.soilList],
            loadingState: 'success',
            error: {},
          });
        }
      })
      .catch((error) => {
      self.setState({
        soilList: [],
        loadingState: 'error',
        error: error,
      });
    });
  }

  render() {
    return (
      <Box className={sharedStyles.scenarioStepSection}>
        {this.state.loadingState === 'loading' &&
          <div>
            <LoadingComponent
              fullwidth={true}
              state='loading'
            />
          </div>
        }
        {this.state.loadingState === 'error' &&
          <div>
            <LoadingComponent
              fullwidth={true}
              state='error'
              error={this.state.error}
            />
          </div>
        }
        {this.state.loadingState === 'success' &&
          <div>
            <Typography variant="h6">
              Soil Type Selection
            </Typography>
            <Typography variant="body1" gutterBottom>
              Select Soil Type to analyse for the selected site.
            </Typography>
            <div>
              <Box
                overflow="auto"
                sx={{ border: "1px solid", borderRadius: "15px", flexGrow: 1, marginTop: "0.5em", padding: "0.5em", paddingBottom: "1em"}}
              >
                <Typography variant="body1" sx={{margin: "0.5em"}}>
                  {this.props.Site}
                </Typography>
                <Divider sx={{width: "100%"}}/>
                <FormGroup row={true}>
                  {/* Soil Type */}
                  <FormControl fullWidth sx={{ margin: "0 1em", marginTop: "1em" }}>
                    <InputLabel>Soil Type</InputLabel>
                    <Select
                      value={this.state.currentSoilType}
                      label="Soil Type"
                      disabled={false}
                      onChange={this.onSoilTypeSelection}
                    >
                      <MenuItem value='soilnone'>
                        <em>None</em>
                      </MenuItem>
                      {this.state.soilList.map((soil) => {
                        return (
                          <MenuItem
                            key={soil.key}
                            value={soil.key}>
                            {soil.description}
                          </MenuItem>
                        )
                      })}
                    </Select>
                  </FormControl>
                </FormGroup>
              </Box>
            </div>
          </div>
        }
        {this.state.soilList.length > 0 && 
          <Box sx={{ width: "100%", marginTop: "1em" }}>
            <Typography variant="body1">
              Soil Types for site: {this.state.soilList.length || 0}
            </Typography>
          </Box>
        }  
      </Box>
    )
  }
}

FASoilTypeSelectionStep.propTypes = {
  Site: PropTypes.string.isRequired,
  SiteId: PropTypes.number.isRequired,
  SelectedSoil: PropTypes.object,
  handleSoilTypeSelection: PropTypes.func,
}

export default FASoilTypeSelectionStep;
